import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { BottomSheetContentLayout, InlineSelectDatePicker, useOverlayContext } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { formatShortMonthUSDate } from '~/utils/date-formatting';
import { TriageRow } from '../TriageRow/TriageRow';
import s from './TriageEffectiveDateRow.module.scss';
export const GetTriageEffectiveDateRowTID = (parentTestId)=>getTestIds(parentTestId);
export const EffectiveDateRowTestIds = GetTriageEffectiveDateRowTID().EffectiveDateRowTestIds;
const EffectiveDateSheet = (param)=>{
    let { currentValue, onCommit } = param;
    const { t } = useLocaleKeys();
    const { hideBottomSheet } = useOverlayContext();
    const [tempValue, setTempValue] = useState(currentValue);
    const handleSave = ()=>{
        if (tempValue !== currentValue) onCommit(tempValue);
        hideBottomSheet();
    };
    return /*#__PURE__*/ _jsx(BottomSheetContentLayout, {
        contentClassName: s.sheetContent,
        footer: {
            primaryAction: {
                text: t.common.buttons.save(),
                testId: EffectiveDateRowTestIds.MobileSheetSaveButton(),
                onClick: handleSave
            }
        },
        children: /*#__PURE__*/ _jsx(InlineSelectDatePicker, {
            testId: EffectiveDateRowTestIds.DatePicker(),
            value: tempValue,
            onChange: (date)=>setTempValue(date)
        })
    });
};
export const TriageEffectiveDateRow = (param)=>{
    let { model, onModelChange } = param;
    const { t } = useLocaleKeys();
    const { pushBottomSheetPage } = useOverlayContext();
    const label = t.agreementImport.triageModal.effectiveDateLabel();
    const currentDate = model.effectiveDate();
    const mobileBody = currentDate != null ? formatShortMonthUSDate(currentDate) : '';
    const openSheet = ()=>pushBottomSheetPage({
            content: /*#__PURE__*/ _jsx(EffectiveDateSheet, {
                currentValue: currentDate,
                onCommit: (date)=>onModelChange(model.setEffectiveDate(date))
            })
        });
    return /*#__PURE__*/ _jsx(TriageRow, {
        label: label,
        testId: EffectiveDateRowTestIds.Root(),
        mobile: {
            body: mobileBody,
            onEdit: openSheet,
            editTestId: EffectiveDateRowTestIds.MobileEditButton()
        },
        children: /*#__PURE__*/ _jsx(InlineSelectDatePicker, {
            testId: EffectiveDateRowTestIds.DatePicker(),
            value: currentDate,
            onChange: (date)=>onModelChange(model.setEffectiveDate(date))
        })
    });
};
